import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ai-advisory/')({
  // Both keys optional: validateSearch's inferred return type is what callers must satisfy, and a
  // `string | undefined` property is still a required key - every navigate to this route would
  // have to name both params.
  validateSearch: (
    search: Record<string, unknown>,
  ): { conversationId?: string; prefillFrom?: string } => {
    return {
      conversationId: typeof search.conversationId === 'string' ? search.conversationId : undefined,
      // EWM-605: id of an answered conversation whose question should be pre-filled into the
      // composer. An answered advisory is read-only, so the way forward from one that produced no
      // work breakdown is to ask again in a fresh conversation.
      prefillFrom: typeof search.prefillFrom === 'string' ? search.prefillFrom : undefined,
    };
  },
});
